import * as React from "react";
import type { SVGProps } from "react";

const FacilityMall = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M13.3307 8.33366V5.00033C13.3307 3.15949 11.8382 1.66699 9.9974 1.66699V1.66699C8.15656 1.66699 6.66406 3.15949 6.66406 5.00033V8.33366"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.832 17.5007H4.16536C3.70536 17.5007 3.33203 17.1273 3.33203 16.6673V6.66732C3.33203 6.20732 3.70536 5.83398 4.16536 5.83398H15.832C16.292 5.83398 16.6654 6.20732 16.6654 6.66732V16.6673C16.6654 17.1273 16.292 17.5007 15.832 17.5007Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityMall.displayName = "FacilityMall";

export default FacilityMall;
